module.exports = __webpack_public_path__ + "img/valencia-extra.ec679bad.png";